import {Pipe, PipeTransform} from '@angular/core'

interface LocationWithGooglePlace {
  googlePlace?: {
    rating?: number
    userRatingCount?: number
  }
}

interface GooglePlace {
  rating: number
  userRatingCount?: number
}

@Pipe({name: 'bgoAverageGooglePlace', standalone: true})
export class AverageGooglePlacePipe implements PipeTransform {
  transform(locations: LocationWithGooglePlace[]): GooglePlace | undefined {
    let averageGooglePlace: GooglePlace | undefined = undefined
    // Get all the locations that have a google place
    const googlePlaces = locations.map(location => location.googlePlace).filter(isGooglePlace)

    // Return undefined if there are no google places at all
    if (!googlePlaces.length) {
      return averageGooglePlace
    }

    // Don't do calculations
    if (googlePlaces.length === 1) {
      averageGooglePlace = googlePlaces[0]
    } else {
      const addedUpGooglePlace = googlePlaces.reduce(
        (cur, acc) => ({
          rating: cur.rating + acc.rating,
          userRatingCount: (cur.userRatingCount || 0) + (acc.userRatingCount || 0),
        }),
        {
          rating: 0,
          userRatingCount: 0,
        },
      )

      averageGooglePlace = {
        rating: addedUpGooglePlace.rating / googlePlaces.length,
        userRatingCount: addedUpGooglePlace.userRatingCount,
      }
    }

    // Only return google place if rating is above 4
    return averageGooglePlace?.rating && averageGooglePlace?.rating >= 4 ? averageGooglePlace : undefined
  }
}

function isGooglePlace(googlePlace: undefined | GooglePlace): googlePlace is GooglePlace {
  return !!googlePlace?.rating
}
